import { useQuery } from '@tanstack/react-query';
import { getReviewAutomationDashboardQuery } from '../api/getReviewAutomationDashboard';

interface UseGetReviewAutomationDashboardProps {
  siteId: string;
  accountId: string;
  locationId: string;
}

/**
 * Custom hook to fetch review automation dashboard data for a specific accountId & locationId.
 */
export function useGetReviewAutomationDashboard({
  accountId,
  locationId,
  siteId
}: UseGetReviewAutomationDashboardProps) {
  return useQuery(getReviewAutomationDashboardQuery(accountId, locationId, siteId));
}

export default useGetReviewAutomationDashboard;
